import request from '@/router/axios'
import env from '@/config/env'
import globalVariable from '@/config/globalVariable'

const { TIME } = globalVariable

/**
 * 查询城际公司名称
 */
export const getAllLowMerchant = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/getAllLowMerchant',
    method: 'GET',
    timeout: TIME,
  })
}

/**
 * 查询城际车牌号
 * @param
 */
export const getCar = () => {
  return request({
    url: env.ferryUrl + '/c-order/queryMerchantDriverAndCarInfo',
    method: 'POST',
    timeout: TIME,
  })
}

/**
 * 获取线路名称
 * @param params
 */
export const queryAllLowLine = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/queryAllLowLine',
    method: 'GET',
    timeout: TIME,
  })
}

/**
 * 获取票款结算规则分页
 * @param params
 */
export const clarifyTicketPage = (params) => {
  return request({
    url: env.ferryUrl + '/clarify/ticket/page',
    method: 'POST',
    timeout: TIME,
    data: params
  })
}

/**
 * 票款同步清分数据
 * @param params
 */
export const clarifyTicketSync = (endDepartureDate, merchantId, startDepartureDate) => {
  return request({
    url:
      env.ferryUrl +
      `/clarify/ticket/sync?endDepartureDate=${endDepartureDate}&&merchantId=${merchantId}&&startDepartureDate=${startDepartureDate}`,
    timeout: 600000,
    method: 'POST'
  })
}
